module.exports = __webpack_public_path__ + "static/resume-469aa1c3865f3c55d8def4ec38e1107d.png";